import { FC, useCallback, useState } from "react"
import { villageDeleteApi } from "src/domain/api/village/villageDeleteApi"
import { Village } from "src/domain/entities/village"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	village: Village
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const VillageDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	village,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleVillageDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await villageDeleteApi({ id: village.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [village, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Village: ${village.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleVillageDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
